import { ConfigKeys, ConfigMap } from './types';

export const LANGUAGE_CONFIG: ConfigMap = new Map([
  [
    'default', // Если пользователь не из UK и без реферальной ссылки
    {
      config: {
        [ConfigKeys.HideCountryField]: true,
        [ConfigKeys.HideCountryUKDropdown]: false,
        [ConfigKeys.BlockCountryField]: false,
        [ConfigKeys.HideDropAndWins]: false
      }
    }
  ],
  [
    'authorized_uk', // Если пользователь из UK, и авторизован
    {
      config: {
        [ConfigKeys.HideCountryField]: true,
        [ConfigKeys.HideCountryUKDropdown]: false,
        [ConfigKeys.BlockCountryField]: false,
        [ConfigKeys.HideDropAndWins]: true
      }
    }
  ],
  [
    'uk_no_referral', // Если пользователь из UK, но без реферальной ссылки
    {
      config: {
        [ConfigKeys.HideCountryField]: false,
        [ConfigKeys.HideCountryUKDropdown]: false,
        [ConfigKeys.BlockCountryField]: false,
        [ConfigKeys.HideDropAndWins]: false
      }
    }
  ],
  [
    'uk_with_referral', // Если пользователь из UK и с реферальной ссылкой
    {
      config: {
        [ConfigKeys.BlockCountryField]: true,
        [ConfigKeys.HideCountryUKDropdown]: false,
        [ConfigKeys.HideCountryField]: true,
        [ConfigKeys.HideDropAndWins]: true
      }
    }
  ],
  [
    'non_uk_with_referral', // Если пользователь не из UK, но с реферальной ссылкой
    {
      config: {
        [ConfigKeys.HideCountryUKDropdown]: true,
        [ConfigKeys.BlockCountryField]: false,
        [ConfigKeys.HideCountryField]: true,
        [ConfigKeys.HideDropAndWins]: false
      }
    }
  ]
]);
